export type AppViewMode = 'elevated' | 'standard';

export type AppRole =
  | 'viewer'
  | 'editor'
  | 'admin_level_2'
  | 'admin_level_3'
  | 'admin'
  | 'member';

export const STANDARD_APP_HOME = '/domains';

// The workspace a standard user gets: the Dashboard, the three domain tools,
// and ATBS. Domain Exceptions live inside the Domain Whitelist page, so
// '/domains' carries them. This stays an allowlist rather than a denylist, so a
// route nobody has thought about is restricted until it is named here.
const STANDARD_APP_PATHS = new Set([
  '/',
  '/domains',
  '/domain-directory',
  '/domain-processing',
  '/atbs',
]);

// These controls execute production scoring work or change the prompt corpus,
// so they stay visible only in the level-3 administrative workspace.
const ELEVATED_ONLY_APP_PATHS = new Set([
  '/atbs/test-bench',
  '/atbs/calibration',
  '/atbs/insights',
]);

export function isElevatedRole(role: AppRole | null | undefined): boolean {
  return role === 'admin_level_3';
}

function normalizeAppPath(pathname: string): string {
  const trimmed = pathname.trim().toLowerCase();
  return trimmed.length > 1 ? trimmed.replace(/\/+$/, '') : trimmed;
}

export function canAccessAppPath(viewMode: AppViewMode, pathname: string): boolean {
  if (viewMode === 'elevated') return true;

  const path = normalizeAppPath(pathname);
  if (ELEVATED_ONLY_APP_PATHS.has(path)) return false;

  return STANDARD_APP_PATHS.has(path) || path.startsWith('/atbs/');
}

export function getDefaultAppPath(viewMode: AppViewMode): string {
  return viewMode === 'elevated' ? '/' : STANDARD_APP_HOME;
}
